<template>
  <div class="app bg-gray" id="myRegister-myRegister">
    <section class="thick">
      <hospital-select @selected="selectHospital"></hospital-select>
      <voucher-select
        :list="voucherList"
        @selected="selectVoucher"
      ></voucher-select>
      <div class="query-more">
        <span>此处展示近三个月的历史记录</span>
        <button class="btn-ok" @click="loadMore()">更多</button>
      </div>
    </section>
    <div class="query-history" v-show="isChoose">
      <div class="time">请选择查询时间段</div>
      <div class="history-more">
        <div class="option" id="StartDate" @click="setStartDate">
          {{ startDate }}
        </div>
        <span></span>
        <div class="option" id="EndDate" @click="setEndDate">{{ endDate }}</div>
        <button class="btn-ok" @click="chooseNewDate()">确定</button>
      </div>
    </div>
    <scroll id="my-register-scroll" class="from-query-more" @refresh="refresh">
      <no-record
        id="myregister-norecord"
        :condition="regList"
        tips="抱歉，没有挂号记录"
      ></no-record>
      <section
        :id="'myregister-list-' + index"
        class="thick"
        v-for="(reg, index) in regList"
        @click="goRegDetail(reg)"
      >
        <div class="panel ellipsis">
          {{ reg.deptName }}&nbsp;&nbsp;{{ reg.doctName }}&nbsp;&nbsp;{{
            reg.rankName | formatBracket
          }}
        </div>
        <div class="content arr-row f-minor">
          <span>挂号时间</span>&nbsp;&nbsp;&nbsp;&nbsp;<span>{{
            reg.orderTime | formatDate
          }}</span>
          <br />
          <span>就诊时间</span>&nbsp;&nbsp;&nbsp;&nbsp;<span>{{
            reg.visitTime | formatDate
          }}</span>
        </div>
        <div class="bottom" style="text-align: right">
          <span
            v-if="
              reg.regStatus === 4 &&
              (reg.orderStatus === 1 || reg.orderStatus === 2)
            "
            class="order-status f-minor"
            >已预约</span
          >
          <span v-if="reg.regStatus === 5" class="order-status f-minor"
            >已取消</span
          >
          <span v-if="reg.orderStatus === 3" class="order-status f-minor"
            >已支付</span
          >
          <span v-if="reg.orderStatus === 4" class="order-status f-strong"
            >已支付</span
          >
          <span v-if="reg.orderStatus === 5" class="order-status f-minor"
            >已退号</span
          >
          <span v-if="reg.orderStatus === 6" class="order-status f-minor"
            >已退号</span
          >
          <button
            v-if="
              (reg.orderStatus === 2 || reg.orderStatus === 1) &&
              reg.regStatus != 5
            "
            @click.stop="select(reg, index, 'cancel')"
            class="btn-minor-red"
          >
            取消
          </button>
          <button
            v-if="reg.orderStatus === 2 && reg.regStatus === 4"
            @click.stop="goPay(reg)"
            class="btn-minor-orange"
          >
            缴费
          </button>
          <button
            v-if="reg.orderStatus === 4"
            @click.stop="select(reg, index, 'fade')"
            class="btn-minor-orange"
          >
            退号
          </button>
        </div>
      </section>
    </scroll>
    <confirm
      :text="confirmMsg"
      v-model="showConfirm"
      @on-sure="confirm"
    ></confirm>
    <payConfirm v-model="showPayConfirm"></payConfirm>
  </div>
</template>
<script>
import Confirm from 'Confirm'
import NoRecord from 'NoRecord'
import myRegisterService from 'myRegister.service'
import queryFun from 'queryFunList.service'
import queryVoucher from 'voucher.service'
import VoucherSelect from 'VoucherSelect'
import HospitalSelect from 'HospitalSelect'
import PayConfirm from 'PayConfirm'
import voucherService from 'voucher.service'

var config = {
  cancel: {
    msg: '确认取消预约？',
    handler () {
      //取消预约
      var params = {
        cardType: this.voucher.cardType,
        cardNo: this.voucher.cardNo,
        orderId: this.selectedReg.orderId
      };
      myRegisterService.unLock(params).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }
        // 修改当前状态为已取消
        this.regList[this.selectedIndex].regStatus = 5;
        this.$utils.alert('取消成功');
      })
    }
  },
  fade: {
    msg: '确认退号？',
    handler () {
      //退号
      var params = {
        orderId: this.selectedReg.orderId
      };
      myRegisterService.refund(params).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          // 退号成功，退费失败。
          if (res.errorCode === 11079005) {
            // 修改当前状态为已退号(未退费)
            this.regList[this.selectedIndex].orderStatus = this.constant.ORDER_STATUS.NO_REFUND;
          }
          return;
        }
        // 修改当前状态为已退号
        this.regList[this.selectedIndex].orderStatus = this.constant.ORDER_STATUS.RETIRED_NUMBER;
        this.$utils.alert('退号成功，退款到账时间以银行到账时间为准。');
      })
    }
  }
}

export default {
  components: {
    Confirm,
    PayConfirm,
    NoRecord,
    HospitalSelect,
    VoucherSelect
  },
  data () {
    var data = {
      isChoose: false,
      showConfirm: false,
      showPayConfirm: false,
      confirmMsg: '',
      regList: [],
      selectedIndex: -1,
      selectedReg: null,
      orderId: '',
      confirmOpration: '',
      voucher: {},
      voucherList: [],
      startDate: '',
      endDate: ''
    };
    return data
  },
  created () {
    //判断是否存在tokenId,且当前界面code失效
    var query = this.$router.currentRoute.query
    var code = query.code
    if (code) {
      var getTokenParams = { code: code }
      voucherService.getToken(getTokenParams).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          //查询该用户未使用过该公众号
          this.loadVouchers()
          return
        }

        //缓存最新code给后台
        localStorage.setItem('deviceId', code);
        sessionStorage.setItem('deviceId', code);
        //返回新token保存本地使用
        localStorage.tokenId = res.data.tokenId;
        localStorage.setItem('tokenId', res.data.tokenId);
        sessionStorage.setItem('tokenId', res.data.tokenId);
        window.http.headers.common['tokenId'] = localStorage.tokenId || ''
        window.http.headers.common['deviceId'] = localStorage.deviceId || ''
        this.loadVouchers()
      })
    } else {
      this.loadVouchers()
    }
  },
  methods: {
    refresh: function () {
      if (!this.voucher.cardType) {
        return this.$utils.alert('请先绑定诊疗卡')
      }
      var params = {
        cardType: this.voucher.cardType,
        cardNo: this.voucher.cardNo,
      }

      //处理初始进入微信的未选医院情况
      if (typeof (http.headers.common['hospitalId']) === "undefined") {
        this.$utils.alert("请选择医院");
        return;
      }

      this.loadRegisterList(params);
    },
    loadVouchers: function () {
      // 获取用户就诊凭证
      queryVoucher.getVoucherList().then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }

        const data = res.data;
        if (data.length === 0) {
          this.$utils.alert('请先绑定诊疗卡');
          return;
        }
        this.voucherList = data;
        // 首次进入，默认第一张诊疗卡信息
        this.voucher = JSON.parse(JSON.stringify(this.voucherList[0]));

        // 保存默认卡信息
        this.$store.commit('updateParam', {
          namespace: 'mypay',
          voucher: this.voucher,
        });
        this.refresh();
      });
    },
    selectHospital: function () {
      this.regList = this.constant.ARRAY_CLEAN;
      this.refresh();
    },
    selectVoucher: function (v) {
      this.regList = this.constant.ARRAY_CLEAN;
      this.voucher = v;

      //保存默认卡信息
      this.$store.commit('updateParam', {
        namespace: 'mypay',
        voucher: v
      });
      //加载默认卡的待缴费列表
      this.refresh();
    },
    loadRegisterList: function (params) {
      queryFun.getMyRegisterList(params).then((res) => {
        if (typeof res === "string") {
          //this.$utils.alert(res);
          this.regList = []
          return;
        }
        this.regList = res || [];
      })
    },
    goRegDetail: function (reg) {
      //将数据存入本地
      this.$store.commit('updateParam', {
        namespace: 'regDetail',
        isPaySuccess: false,
        registerInfo: {
          cardType: this.voucher.cardType,
          cardNo: this.voucher.cardNo,
          orderType: this.constant.ORDER_TYPE.REGISTRATION_TYPE,
          orderId: reg.orderId
        }
      });
      this.$router.push('regdetail');
    },
    select: function (reg, index, confirmOpration) {
      this.showConfirm = true;
      this.confirmOpration = confirmOpration;
      this.confirmMsg = config[confirmOpration].msg;
      this.selectedIndex = index;
      this.selectedReg = reg;
    },
    confirm: function () {
      config[this.confirmOpration].handler.call(this)
    },
    goPay: function (reg) {
      //将数据存入本地
      this.$store.commit('updateParam', {
        namespace: 'pay',
        // 支付模块所需要的参数
        payInfo: {
          cardType: this.voucher.cardType,
          cardNo: this.voucher.cardNo,
          orderType: this.constant.ORDER_TYPE.REGISTRATION_TYPE,// 1挂号2门诊
          fee: reg.fee,
          orderId: reg.orderId,
          busiType: this.constant.BUSI_TYPE.REGISTRATION_PAYMENT
        }
      });
      this.$store.commit('updateParam', {
        namespace: 'regDetail',
        // 支付成功后跳转到挂号详情所需要的参数
        registerInfo: {
          cardType: this.voucher.cardType,
          cardNo: this.voucher.cardNo,
          orderId: reg.orderId
        }
      });
      //判断是否0元需求
      if (parseFloat(reg.fee) <= 0) {
        this.zeroPay(reg);
        return;
      }
      this.showPayConfirm = true;
    },
    //0元需求
    zeroPay (response) {
      // 从上级获取参数
      const params = {
        orderId: response.orderId,
        orderType: this.constant.ORDER_TYPE.REGISTRATION_TYPE,// 1挂号2门诊,
        cardType: this.voucher.cardType,
        cardNo: this.voucher.cardNo,
        channelId: '4',
        // app 1; h5 2; o2o 3;
        invokeType: this.constant.INVOKE_TYPE.WAP_INVOKE,
        busiType: this.constant.BUSI_TYPE.REGISTRATION_PAYMENT,
        fee: response.fee,
        deviceId: localStorage.deviceId || sessionStorage.deviceId || '',
      }
      // 生成外部订单号
      this.loadOutOrder(params)
    },
    loadOutOrder (params) {
      this.$http.post('/app/pay/order', params).then((res) => {
        if (res.data.resultCode === this.constant.RESULT_SUCCESS) {
          // 跳转支付成功或失败界面
          this.$store.commit('updateParam', {
            namespace: 'paySuccess',
            paySuccessInfo: {
              orderId: params.orderId,
              fee: params.fee,
              busiType: params.busiType,
            },
          })
          this.$router.replace('paySuccess')
        } else {
          this.$utils.alert(res.data.resultMsg)
        }
      })
    },
    //默认初始化日历控件
    formatDatePicker () {
      var dateOb = new Date()
      var year = dateOb.getFullYear()
      var month = dateOb.getMonth()
      var day = dateOb.getDate()
      var lastDay = new Date(year, month, day);
      this.startDate = lastDay.format('yyyy-MM-dd')
      this.endDate = lastDay.format('yyyy-MM-dd')
    },
    //判断日期是否合法
    checkDate (sDate, eDate) {
      var formate = new RegExp(/-/g);
      sDate = sDate.replace(formate, "");
      eDate = eDate.replace(formate, "");
      //判断日期大小及合法性
      if ((sDate > eDate) || (sDate === '') || (eDate === '')) {
        this.$utils.alert('日期输入格式不正确，请重新输入');
        return false
      }
      return true
    },
    /* eslint-disable */
    loadMore () {
      this.isChoose = !this.isChoose
      if (this.isChoose) {
        $("#my-register-scroll").addClass("include-date-scroll")
        $("#my-register-scroll").removeClass("from-query-more")
        $("#my-register-scroll").removeClass("scroll")
      } else {
        $("#my-register-scroll").removeClass("include-date-scroll")
        $("#my-register-scroll").addClass("from-query-more")
        $("#my-register-scroll").addClass("scroll")
      }
      //初始化日期控件
      this.formatDatePicker();
    },
    setStartDate () {
      const today = new Date()
      var maxDate = today.format('yyyy-MM-dd')
      today.setMonth(today.getMonth() - 12)
      var minDate = today.format('yyyy-MM-dd')
      this.$picker.show({
        type: 'datePicker',
        date: this.startDate,  //初始化时间
        endTime: maxDate,  //截至时间
        startTime: minDate,  //开始时间
        onOk: (e) => {
          //格式化成统一格式
          var newDate = new Date(e.replace(/-/g, "/"))
          this.startDate = newDate.format('yyyy-MM-dd')
        }
      });
    },
    setEndDate () {
      const today = new Date()
      var maxDate = today.format('yyyy-MM-dd')
      today.setMonth(today.getMonth() - 12)
      var minDate = today.format('yyyy-MM-dd')
      this.$picker.show({
        type: 'datePicker',
        date: this.endDate,  //初始化时间
        endTime: maxDate,  //截至时间
        startTime: minDate,  //开始时间
        onOk: (e) => {
          //格式化成统一格式
          var newDate = new Date(e.replace(/-/g, "/"))
          this.endDate = newDate.format('yyyy-MM-dd')
        },
      })
    },
    chooseNewDate () {
      var params = {
        cardType: this.voucher.cardType,
        cardNo: this.voucher.cardNo
      };
      if (this.checkDate(this.startDate, this.endDate)) {
        params.startDate = this.startDate
        params.endDate = this.endDate
        this.loadRegisterList(params);
      }
    }
  },
  watch: {
    regList (val) {
      if (val.length === 0) {
        this.noRecord = true;
      } else {
        this.noRecord = false;
      }
    }
  }
}
</script>

<style lang="scss">
.order-status {
  float: left;
}
.include-date-scroll {
  top: 6rem;
  position: absolute;
  bottom: 0;
  width: 100%;
  overflow-y: auto;
  padding-bottom: 0.5rem;
  background: #eff2f5;
}
</style>



// WEBPACK FOOTER //
// MyRegister.vue?a771d7dc